import { combineReducers } from '@reduxjs/toolkit'
import environment from '../features/environment/environmentSlice'
import auth from '../auth/authSlice'
import user from '../features/user/userSlice'
import interpreter from '../features/interpreter/interpreterSlice'
import subtitles from '../features/subtitles/subtitlesSlice'


const rootReducer = combineReducers({
  environment,
  auth,
  user,
  interpreter,
  subtitles,
})

export default rootReducer
